import { render } from "./Notice.vue?vue&type=template&id=35469ff0"
import script from "./Notice.vue?vue&type=script&lang=ts"
export * from "./Notice.vue?vue&type=script&lang=ts"
script.render = render

export default script